function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M10.49 2.23L5.5 4.1c-1.15.43-2.09 1.79-2.09 3.02v7.43c0 1.18.78 2.73 1.73 3.44l4.3 3.21c1.41 1.06 3.73 1.06 5.14 0l4.3-3.21c.95-.71 1.73-2.26 1.73-3.44V7.12c0-1.23-.94-2.59-2.09-3.02l-4.99-1.87c-.85-.31-2.21-.31-3.04 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9 11.3h.1c1.15-.04 2.05-.97 2.06-2.13 0-1.18-.96-2.14-2.14-2.14-1.18 0-2.14.96-2.14 2.14.02 1.15.92 2.09 2.12 2.13zm2.29 2.11c-1.21-.8-3.17-.8-4.39 0-.56.38-.89.92-.89 1.48 0 .57.32 1.09.89 1.47.61.4 1.4.61 2.19.61s1.59-.2 2.19-.61c.56-.38.89-.92.89-1.48.01-.57-.31-1.09-.88-1.47z"
})));